import React, { useState } from "react";
import toast, { Toaster } from 'react-hot-toast';
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { useFormik } from 'formik';
import HeroImg from "../../Shared components/HeroImg";
import { Config } from "../../API/config";
import BeatLoader from "react-spinners/BeatLoader";
import axios from "axios";
import BasicNavbar from "../Navbar/BasicNavbar";

interface Message {
    message: string;
}

const ContactUs = () => {
    const [viewPassword, setViewPassword] = useState(false);
    const navigate = useNavigate();
    const [isLoading, setLoading] = useState(false);

    const validationSchema = Yup.object({
        message: Yup.string()
            .required("Message is required"),
    });

    async function sendData(values: Message) {


        try {
            setLoading(true);
            let { data } = await axios.post(Config.sendContactUs, values, {
                withCredentials: true
            });
            if (data.statusCode === 201) {
                toast.success("تم ارسال الرسالة بنجاح");
            }
        } catch (error) {
            toast.error("حدث خطأ ما");
        } finally {
            setLoading(false);
        }
    }

    const formik = useFormik({
        initialValues: {
            message: "",
        },
        validationSchema,
        onSubmit: sendData,
    });

    return (
        <>
            <Toaster />
            <BasicNavbar />
            <div className="flex flex-row min-h-screen w-full">
                <HeroImg />
                <div className="flex flex-col items-end justify-start w-full mt-10 px-6 md:px-16 lg:px-24 relative">
                    <div className="w-full flex flex-col items-end text-right">
                        <h2 className="text-2xl md:text-3xl lg:text-[32px] leading-tight font-medium text-neutral-900">
                            Otlob Coach مرحباً بكم في
                        </h2>
                        <p className="text-sm md:text-base leading-6 font-normal text-neutral-900 mt-2">
                            تواصل مع فريقنا الودود
                        </p>
                    </div>
                    <div className="w-full my-3">
                        <form onSubmit={formik.handleSubmit}>
                            <textarea
                                onChange={formik.handleChange}
                                value={formik.values.message}
                                onBlur={formik.handleBlur}
                                id="message"
                                name="message"
                                className="text-right border border-gray-300 text-black text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-4"
                                rows={4}
                                style={{ resize: 'none' }}
                            />
                            {formik.touched.message && formik.errors.message && (
                                <p className="text-red-500 text-xs mt-1">{formik.errors.message}</p>
                            )}
                            <div className="w-full my-5 flex justify-end">
                                {isLoading ? (
                                    <BeatLoader className="mt-5" color="#072605" />
                                ) : (
                                    <button
                                        type="submit"
                                        aria-label="Send message"
                                        className="bg-white text-primary-500 p-2 w-full mt-5 border rounded-md border-primary-500 md:w-[158px] hover:bg-primary-500 hover:text-white hover:border-transparent transition-all duration-500"
                                    >
                                        ارسال الرسالة
                                    </button>
                                )}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ContactUs;
